import React from 'react';
import I18n from '@utils/i18n';
import { Calendar, CalendarHeaderTitle, CalendarNavigationItem, DatePicker } from '@progress/kendo-react-dateinputs';

function CustomHeaderTitle(props) {
  return (
    <CalendarHeaderTitle {...props}>
      <div />
    </CalendarHeaderTitle>
  );
}

function CustomNavigationItem(props) {
  const { text, value } = props;

  // Replace year with "Jan [Year]"
  if (text && value && /^\d{4}$/.test(text)) {
    const year = value.getFullYear();

    return (
      <CalendarNavigationItem {...props}>
        {I18n.t('date.abbr_month_names')[1]} {year}
      </CalendarNavigationItem>
    );
  }

  return <CalendarNavigationItem {...props} />;
}

function DatePickerWoYear({ min, max, hideHeaderTitle, ...props }) {
  // Increase the width of the navigation column to properly display 'Jan [Year]'
  const handleCalendarOpen = () => {
    setTimeout(() => {
      // Target the most recently opened popup (last k-animation-container)
      const popupContainers = document.querySelectorAll('.k-animation-container');
      const lastPopup = popupContainers[popupContainers.length - 1];

      if (lastPopup) {
        const navList = lastPopup.querySelector('ul.k-reset');
        if (navList) {
          const navContainer = navList.parentElement;
          const width = '90px';
          navList.style.width = width;
          navContainer.style.width = width;
          if (navContainer.parentElement) {
            navContainer.parentElement.style.width = width;
          }
        }
      }
    }, 50);
  };

  const calendarProps = { navigationItem: CustomNavigationItem };
  if (hideHeaderTitle) { calendarProps.headerTitle = CustomHeaderTitle; }

  const CustomCalendarComponent = (calProps) => (
    <Calendar {...calendarProps} {...calProps} />
  );

  return (
    <DatePicker
      {...props}
      width={200}
      calendar={CustomCalendarComponent}
      format="MM/dd"
      onOpen={handleCalendarOpen}
      min={min}
      max={max}
    />
  );
}

export default DatePickerWoYear;
